var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicesLightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.636,
    viewBox: "0 0 24 19.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M43.273-823.636a2.1,2.1,0,0,1-1.541-.641,2.1,2.1,0,0,1-.641-1.541v-12a2.1,2.1,0,0,1,.641-1.541A2.1,2.1,0,0,1,43.273-840H60.727a2.1,2.1,0,0,1,1.541.641,2.1,2.1,0,0,1,.641,1.541v12a2.1,2.1,0,0,1-.641,1.541,2.1,2.1,0,0,1-1.541.641ZM40-820.364v-2.182H64v2.182Z",
    transform: "translate(-40 840)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesLightIcon);
export default __webpack_public_path__ + "static/media/devices_light_icon.a8f689937688c22e580a4468c3e119e6.svg";
export { ForwardRef as ReactComponent };